// sub-type of select
// DEFAULT: normal select
// CREATABLE: select that allows user to create options
// future... ASYNC, ASYNCCREATABLE
export default {
	DEFAULT: 'DEFAULT',
	CREATABLE: 'CREATABLE'
};
